/**
 * This JS file should have all common JS accross the site
 * TODO: Separate out file - no point in enqueing map on every page
 *
 */
Element.prototype.hasClass = function (className) {
	return (
		this.className &&
		new RegExp("(^|\\s)" + className + "(\\s|$)").test(this.className)
	);
};

/**
 * Create global fellowship namespace in Javascript
 * @type {*|{}}
 */
window.fellowship = window.fellowship || {};
fellowship = fellowship || {};

/**
 * If emergency banner present, shift nav elements down
 */
let has_ebm = document.querySelector('#ebm');
if(has_ebm !== null) {
	let body_el = document.querySelector('body');
	body_el.classList.add('has_ebm');
}

/**
 * Toggle Home page search boxes
 */
let toggleSearchBoxes = document.querySelectorAll(".box .header");
if (toggleSearchBoxes !== null) {
	for (let i = 0; i < toggleSearchBoxes.length; i++) {
		toggleSearchBoxes[i].addEventListener("click", function (e) {
			e.preventDefault();
			let container = e.target.parentNode;
			container.classList.toggle("open");
		});
	}
}

// de-obfuscate contact emails in gutenberg block
let ccontainer = document.querySelector('.contacts-container');
if(ccontainer !== null){
	let erebus = document.querySelectorAll('a.erebus');
	for (let i = 0; i < erebus.length; i++) {
		if(erebus[i].hasAttribute('data-target')){
			let x = erebus[i].dataset.target;
			let dec_x = atob(x);
			erebus[i].href = 'mailto:' + dec_x;
			if(erebus[i].innerHTML === '') {
				erebus[i].innerHTML = dec_x;
			}
		}
	}
}

fellowship.jumpToHeading = function(text) {
	let headings = document.getElementsByTagName('h2');

	for(let i=0;i<headings.length;i++){

		if(headings[i].innerHTML === text){

			headings[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
			break;

		}

	}
}

fellowship.filterCaseStudies = function(elem) {
	top.location.href = elem.firstElementChild.options[elem.firstElementChild.selectedIndex].value
	return false;
}

/**
 * Add JSON from File to a variable
 * Accepts a reference to existing varaible
 * prevent warnings about missing objects by defining it first:
 * let object = {};
 * object.data = undefined;
 * @param file
 * @param reference
 * @returns reference.data
 */
fellowship.addDataFromFile = async function (file, reference) {

	let response = await fetch(file, {cache: "force-cache"});

	if (response.ok) { // if HTTP-status is 200-299

		reference["data"] = await response.json();

	} else {
		console.log("HTTP-Error: " + response.status);
	}

	return reference;

};

/**
 * Autocomplete from JSON file.
 * Accepts array.name or array.code for Railways
 * Can be used anywhere.
 *
 * @param input
 * @param file
 */
fellowship.autocomplete = function(input, file) {
	let autocompleteArray = {};
	autocompleteArray.data = undefined;

	fellowship.addDataFromFile(file, autocompleteArray);

	/*the autocomplete function takes two arguments,
	the text field element and an array of possible autocompleted values:*/
	let currentFocus;
	/*execute a function when someone writes in the text field:*/
	input.addEventListener("input", function (e) {
		let a, b, i, val = this.value;
		/*close any already open lists of autocompleted values*/
		fellowship.closeAllLists();
		if (!val) {
			return false;
		}
		currentFocus = -1;
		/*create a DIV element that will contain the items (values):*/
		a = document.createElement("DIV");
		a.setAttribute("id", this.id + "autocomplete-list");
		a.setAttribute("class", "autocomplete-items");
		/*append the DIV element as a child of the autocomplete container:*/
		this.parentNode.appendChild(a);
		/*for each item in the array...*/
		for (i = 0; i < autocompleteArray.data.length; i++) {
			/*check if the item starts with the same letters as the text field value:*/
			if (autocompleteArray.data[i].name.substr(0, val.length).toUpperCase() === val.toUpperCase() || autocompleteArray.data[i].code.substr(0, val.length).toUpperCase() === val.toUpperCase()) {
				/*create a DIV element for each matching element:*/
				b = document.createElement("DIV");
				/*make the matching letters bold:*/
				b.innerHTML = `<strong>${autocompleteArray.data[i].name.substr(0, val.length)}</strong>`;
				b.innerHTML += `<a href="/${autocompleteArray.data[i].code.toLowerCase()}">${autocompleteArray.data[i].name.substr(val.length)}</a>`;
				/*insert a input field that will hold the current array item's value:*/
				b.innerHTML += `<input type="hidden" value="${autocompleteArray.data[i].code}">`;
				/*execute a function when someone clicks on the item value (DIV element):*/
				b.addEventListener("click", function (e) {
					/*insert the value for the autocomplete text field:*/
					input.value = this.getElementsByTagName("input")[0].value;
					/*close the list of autocompleted values,
					(or any other open lists of autocompleted values:*/
					fellowship.closeAllLists();
				});
				a.appendChild(b);
			}
		}
	});
	/*execute a function presses a key on the keyboard:*/
	input.addEventListener("keydown", function (e) {
		let x = document.getElementById(this.id + "autocomplete-list");
		if (x) x = x.getElementsByTagName("div");
		if (e.keyCode === 40) {
			/*If the arrow DOWN key is pressed,
			increase the currentFocus variable:*/
			currentFocus++;
			/*and and make the current item more visible:*/
			fellowship.addActive(x);
		} else if (e.keyCode === 38) { //up
			/*If the arrow UP key is pressed,
			decrease the currentFocus variable:*/
			currentFocus--;
			/*and and make the current item more visible:*/
			fellowship.addActive(x);
		} else if (e.keyCode === 13) {
			/*If the ENTER key is pressed, prevent the form from being submitted,*/
			e.preventDefault();
			if (currentFocus > -1) {
				x = x[currentFocus].getElementsByTagName("a");
				/*and simulate a click on the "active" item:*/
				if (x) x[currentFocus].click();
			}
		}
	});

	fellowship.addActive = function(x) {
		/*a function to classify an item as "active":*/
		if (!x) return false;
		/*start by removing the "active" class on all items:*/
		fellowship.removeActive(x);
		if (currentFocus >= x.length) currentFocus = 0;
		if (currentFocus < 0) currentFocus = (x.length - 1);
		/*add class "autocomplete-active":*/
		x[currentFocus].classList.add("autocomplete-active");
	}

	fellowship.removeActive = function(x) {
		/*a function to remove the "active" class from all autocomplete items:*/
		for (let i = 0; i < x.length; i++) {
			x[i].classList.remove("autocomplete-active");
		}
	}

	fellowship.closeAllLists = function(element) {
		/*close all autocomplete lists in the document,
		except the one passed as an argument:*/
		let x = document.getElementsByClassName("autocomplete-items");
		for (let i = 0; i < x.length; i++) {
			if (element !== x[i] && element !== input) {
				x[i].parentNode.removeChild(x[i]);
			}
		}
	}
	/*execute a function when someone clicks in the document:*/
	document.addEventListener("click", function (e) {
		fellowship.closeAllLists(e.target);
	});
}

let micrositeNavToggle = document.querySelector('#microsite-nav');
if(micrositeNavToggle !== null) {
	micrositeNavToggle.onclick = function() {
		let text = document.querySelector('#microsite-nav span').innerHTML;
		document.querySelector('#microsite-nav span').innerHTML = (text === '+') ? '-' : '+';
		let micrositeNavItems = document.querySelector('.microsite_main_nav_items');
		micrositeNavItems.classList.toggle('show');
	};
}


fellowship.getNextSibling = function (elem, selector) {

	// Get the next sibling element
	var sibling = elem.nextElementSibling;

	// If the sibling matches our selector, use it
	// If not, jump to the next sibling and continue the loop
	while (sibling) {
		if (sibling.matches(selector)) return sibling;
		//sibling = sibling.nextElementSibling
	}

};

let storageOpenRow = document.querySelectorAll('.state-row');
if(storageOpenRow !== null) {
	for (let i = 0; i < storageOpenRow.length; i++) {
		storageOpenRow[i].addEventListener('click', function(row) {
			let cell = storageOpenRow[i].getElementsByTagName("td")[0];
			let plusMinus = cell.getElementsByTagName("span")[0];
			plusMinus.innerHTML = (plusMinus.innerHTML === '+') ? '-' : '+';
			let toggle = fellowship.getNextSibling(storageOpenRow[i], '.row')
			toggle.classList.toggle('hide');
		});
	}
}

let storageRailroadSelect = document.querySelector('#filter_rr');
let storageStateSelect = document.querySelector('#filter_states');

if(storageRailroadSelect !== null) {
	storageRailroadSelect.addEventListener('change', function() {
		fellowship.resetFilters('none');
		fellowship.filterRailroad(this.value, true);
		storageStateSelect.value = 0;
	});
}
if(storageStateSelect !== null) {
	storageStateSelect.addEventListener('change', function() {
		fellowship.resetFilters('none');
		fellowship.filterState(this.value);
		storageRailroadSelect.value = 0;
	});
}

let storageSortReset = document.querySelector('#sort_reset');
if(storageSortReset !== null) {
	storageSortReset.addEventListener('click', function(e) {
		e.preventDefault();
		fellowship.resetFilters('table');
		storageRailroadSelect.value = 0;
		storageStateSelect.value = 0;
	});
}

fellowship.filterRailroad = function(marker, single = false) {
	let row = document.querySelector("[data-railroad='" + marker + "']");
	row.style.display = "table";
	console.log(row);
	let test = row.dataset.states.split(',');
	if (Array.isArray(test)) {
		for (let i = 0; i < test.length; i++) {
			fellowship.filterState(test[i], single);
		}
	} else {
		fellowship.filterState(row.dataset.states, single);
	}
}

fellowship.filterState = function(state, single) {
	let row = document.querySelector("[data-state='" + state + "']");
	if(row !== null) {
		row.style.display = "table";

		let cell = row.getElementsByTagName("td")[0];
		let plusMinus = cell.getElementsByTagName("span")[0];
		plusMinus.innerHTML = (plusMinus.innerHTML === '+') ? '-' : '+';
		let toggle = fellowship.getNextSibling(row, '.row')
		toggle.classList.toggle('hide');
		fellowship.showAllRailroads(single);
	}
}

fellowship.showAllRailroads = function(single) {
	if(!single) {
		let l = document.querySelectorAll('.storage-list-item');
		for (let i = 0; i < l.length; i++) {
			l[i].style.display = 'table';
		}
	}

}

fellowship.resetFilters = function(display) {
	let l = document.querySelectorAll('.storage-list-item');
	for (let i = 0; i < l.length; i++) {
		l[i].style.display = display;
	}

	let x = document.querySelectorAll('.state-row');
	for (let i = 0; i < x.length; i++) {
		x[i].style.display = display;
		if(display === 'table') {
			let cell = x[i].getElementsByTagName("td")[0];
			let plusMinus = cell.getElementsByTagName("span")[0];
			plusMinus.innerHTML = '+';
		}
	}

	let r = document.querySelectorAll('.row');
	for (let i = 0; i < r.length; i++) {
		r[i].classList.add('hide');
	}
}









/*fellowship.sortStorageList = function(marker, state, type) {
	let display = (type === 'reset') ? 'table' : 'none'
	let l = document.querySelectorAll('.storage-list-item');
	for (let i = 0; i < l.length; i++) {
		l[i].style.display = display;
	}

	let x = document.querySelectorAll('.state-row');
	for (let i = 0; i < x.length; i++) {
		x[i].style.display = display;
	}
	let r = document.querySelectorAll('.row');
	for (let i = 0; i < r.length; i++) {
		r[i].classList.add('hide');
	}

	storageStateSelect.value = state;
	storageRailroadSelect.value = marker;

	if(type === 'reset') {
		storageStateSelect.value = 0;
		storageRailroadSelect.value = 0;
	}
	fellowship.toggleRows(marker, state);

	if(Array.isArray(state)) {
		for (let i = 0; i < state.length; i++) {
			fellowship.makeRowStateTable(state[i]);
		}
		return;
	} else {
		fellowship.makeRowStateTable(state);
	}
}

fellowship.toggleRows = function(marker, state) {
	let row;
	console.log(marker);
	if(marker !== 0 && state !== 0) {
		row = document.querySelector("[data-railroad='" + marker + "']");
		row.style.display = "table";
		let test = row.dataset.states.split(',');
		if (Array.isArray(test)) {
			for (let i = 0; i < test.length; i++) {
				fellowship.makeRowStateTable(test[i]);
			}
		} else {
			fellowship.makeRowStateTable(row.dataset.states);
		}
	}
	if(marker === 0 && state !== 0) {
		let test = state.split(',');
		if(Array.isArray(test)) {
			for (let i = 0; i < test.length; i++) {
				fellowship.makeRowStateTable(test[i]);
			}
		} else {
			fellowship.makeRowStateTable(state);
		}
	}
}


fellowship.makeRowTable = function(marker) {
	if(marker !== 0) {
		let row = document.querySelector("[data-railroad='" + marker + "']");
	}
}
fellowship.makeRowStateTable = function(state) {
	if(state !== 0) {
		let row = document.querySelector("[data-state='" + state + "']")
		row.style.display = "table";

		let cell = row.getElementsByTagName("td")[0];
		let plusMinus = cell.getElementsByTagName("span")[0];
		plusMinus.innerHTML = (plusMinus.innerHTML === '+') ? '-' : '+';
		let toggle = fellowship.getNextSibling(row, '.row')
		toggle.classList.toggle('hide');
	}
}*/

fellowship.getParameterByName = function(name, url = window.location.href) {
	name = name.replace(/[\[\]]/g, '\\$&');
	let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const queryStringRailroad = fellowship.getParameterByName('railroad');
const queryStringState = fellowship.getParameterByName('state');

if(queryStringRailroad !== null) {
	fellowship.resetFilters('none');
	fellowship.filterRailroad(queryStringRailroad, true);
	storageStateSelect.value = 0;
	storageRailroadSelect.value = 0;
	window.history.pushState({}, document.title, window.location.href.split("?")[0]);
}

fellowship.cssFader = function(slider,delay,fadetime) {
	if(slider === undefined) {
		return;
	}
	let n = 0;
	let p = delay;
	let slide = document.querySelectorAll('#'+ slider + ' > picture').length;
	if(slide <= 1) {
		return;
	}
	for (let i=0; i<slide; i++) {
		n = i + 1;
		let t = i * p;
		document.querySelector('head').innerHTML += "<style> #"+slider+" picture:nth-of-type("+n+") {position: absolute; top: 0; left: 0; height: 100%; width: 100%; animation-delay: "+t+"s;} </style>";
	}
	document.querySelector('head').innerHTML += "<style> #"+slider+" picture { opacity: 0; animation: anim-"+slider+" "+(n*p)+"s infinite;} </style>";
	document.querySelector('head').innerHTML += "<style> @keyframes anim-"+slider+" { 0% { opacity: 0; z-index: 100;} "+fadetime+"% { opacity: 1;} "+(100-fadetime)+"% { opacity: 1;} 100% { opacity: 0; z-index: 1;}} </style>";
}

const toggleCompare = document.querySelector('.toggle-compare');
if(toggleCompare !== null) {
	toggleCompare.addEventListener('click', function(e) {
		e.preventDefault();
		if (document.querySelector('#compare-footer').classList.contains('active')) {
			document.querySelector('#compare-footer').classList.remove('active');
		} else {
			document.querySelector('#compare-footer').classList.add('active');
		}
	});
}

compareFooter();

// Changes to structure if success stories is loaded on page
const customerSucccessStories = document.querySelector('.block-customer-success-stories');
if(customerSucccessStories !== null) {
	document.body.classList.add("success-slider");
} else {
	document.body.classList.remove("success-slider");
}

// Remove of bottom Left background tranle pattern from site-content
document.querySelectorAll(".site-content").forEach(box => {
	if(box.offsetHeight < 2200) {
		box.classList.add("site-content-sm");
	} else {
		box.classList.remove("site-content-sm");
	}
});

// Show compare checkboxes once loaded
document.querySelectorAll(".id-comp").forEach(box => { box.style.display = "" })

window.onresize = compareFooter;

function compareFooter() {
	if (window.innerWidth > 767) {
		const compareFooter = document.querySelector('#compare-footer');
		if(compareFooter !== null) {
			compareFooter.classList.add('active');
		}
	}
}
function copyToClipboard(event) {
	navigator.clipboard.writeText(window.location.href)
		.then(() => {
			event.target.classList.add('copied');
			setTimeout(function () {
				event.target.classList.remove('copied');
			}, 2500);
			console.log('Copied to clipboard');
		})
		.catch(err => {
			console.error('Error in copying text: ', err);
		});
}

const copyLink = document.querySelector('.copy-to-clipboard');
if(copyLink !== null) {
	copyLink.addEventListener('click', copyToClipboard);
}

//console.clear();
const featuresEl = document.querySelector(".features");
const featureEls = document.querySelectorAll(".feature");
if(featuresEl !== null) {
	featuresEl.addEventListener("pointermove", (ev) => {
		featureEls.forEach((featureEl) => {
			// Not optimized yet, I know
			const rect = featureEl.getBoundingClientRect();

			featureEl.style.setProperty("--x", ev.clientX - rect.left);
			featureEl.style.setProperty("--y", ev.clientY - rect.top);
		});
	});
}
fellowship.cssFader("mast-video-container",7,3);

let mlSwitcher = document.getElementById("mob-language-toggle");
if(mlSwitcher) {
	mlSwitcher.addEventListener('change', function(evt){
		console.log('Lang toggle change...');
		let hrefUrl = '';
		let lang = this.checked ? 'fr' : 'en';
		hrefUrl = document.querySelector('.lang-switch-mobile span.'+lang).dataset.link;
		if(hrefUrl.length > 0) {
			console.log('Navigating to '+hrefUrl);
			window.location.href = hrefUrl;
		}
		else {
			console.log('Language toggle failed');
		}
	});
}

if(window.location.href.indexOf('/calendar/paid') > -1) {
	var email_target = document.getElementById('calendar-customer-email');
	var customer_email = localStorage.getItem('gw_calendar_customer_email');
	if(customer_email != '' && customer_email.indexOf('@') > -1 && email_target) {
		email_target.innerHTML = ' at '+customer_email;
	}
}
